import { useState, useRef, useEffect } from 'react';
import { usePopper } from 'react-popper';
import outy from 'outy';
import cn from 'classnames';
import { useQueryParams } from 'use-query-params';
import { dashboardQueryTypes } from 'utils/query';

import s from './s.module.css';

const options = [
  { title: 'Global', queryKey: undefined },
  { title: 'Asia', queryKey: 'Asia' },
  { title: 'Europe', queryKey: 'Europe' },
  { title: 'Africa', queryKey: 'Africa' },
  { title: 'Oceania', queryKey: 'Oceania' },
  { title: 'South America', queryKey: 'South America' },
  { title: 'Central America', queryKey: 'Central America' },
  { title: 'North America', queryKey: 'North America' },
];

export const Region = ({ tabIndex }) => {
  const [open, setOpen] = useState(false);
  const outyRef = useRef(null);
  const referenceWrapElement = useRef(null);
  const referenceElement = useRef(null);
  const popperElement = useRef(null);
  const [query, setQuery] = useQueryParams(dashboardQueryTypes);

  const { styles, attributes, forceUpdate } = usePopper(
    referenceElement.current,
    popperElement.current,
    {
      placement: 'bottom',
      strategy: 'absolute',
      modifiers: [{ name: 'offset', options: { offset: [0, 12] } }],
    }
  );

  const keyboardHandler = (event) => {
    if (event.key === 'Escape') {
      setOpen(false);
    }
  };

  useEffect(() => {
    if (forceUpdate) {
      forceUpdate();
    }

    if (open) {
      document.addEventListener('keydown', keyboardHandler, false);
      outyRef.current = outy(
        [referenceWrapElement.current, popperElement.current],
        ['click', 'touchstart'],
        () => setOpen(false)
      );
    }

    return () => {
      document.removeEventListener('keydown', keyboardHandler, false);
      if (outyRef.current && outyRef.current.remove) {
        outyRef.current.remove();
      }
    };
  }, [open, setOpen]);

  const handlerChange = (region) => {
    setQuery({ region, offset: undefined, limit: undefined });
    setOpen(false);
  };

  const selectedOption = options.find(
    ({ queryKey }) => queryKey === query.region
  );

  return (
    <>
      <button
        type="button"
        className={cn(s.wrap, { [s.active]: open })}
        ref={referenceWrapElement}
        onClick={() => setOpen((isOpen) => !isOpen)}
        tabIndex={tabIndex}
      >
        <span className={s.label}>
          Select region
          <span className={s.selectedRegion} ref={referenceElement}>
            {selectedOption?.title || options[0]?.title}
          </span>
        </span>
        <svg
          width="24"
          height="24"
          className={cn(s.icon, { [s.active]: open })}
        >
          <use xlinkHref="/sprite.svg#arrowDown" />
        </svg>
      </button>
      <div
        ref={popperElement}
        style={{ ...styles.popper, visibility: open ? 'visible' : 'hidden' }}
        className={s.dropdownWrap}
        {...attributes.popper}
      >
        {options.map(({ title, queryKey }) => (
          <button
            type="button"
            key={title}
            className={cn(s.dropdownItem, {
              [s.active]: queryKey === query.region,
            })}
            onClick={() => handlerChange(queryKey)}
          >
            {title}
          </button>
        ))}
      </div>
    </>
  );
};
